export default () => {
  // directory examples: /online-ordering/cart, /dine-in-ordering/cart
  // `/online-ordering/cart` == ['', 'online-ordering', 'cart'],
  const pathDirectories = window.location.pathname.split('/');
  return `/${pathDirectories[1]}`;
};
